
// This file contains polyfills needed by the application

// Define proper interfaces for our polyfills
interface BufferConstructor {
  from(data: any, encoding?: string): any;
  alloc(size: number): Uint8Array;
  isBuffer(obj: any): boolean;
  // Add other required Buffer methods
  of: any;
  isEncoding: any;
  byteLength: any;
  concat: any;
}

interface Process {
  env: Record<string, string>;
  nextTick: (fn: Function) => number;
  version: string;
  // Add other required process properties
  stdout: any;
  stderr: any;
  stdin: any;
  argv: any;
}

// We need to create a Buffer-like polyfill instead of importing from 'buffer'
if (typeof window !== 'undefined' && typeof window.Buffer === 'undefined') {
  const BufferPolyfill: BufferConstructor = {
    from(data, encoding) {
      return data;
    },
    
    alloc(size) {
      return new Uint8Array(size);
    },
    
    isBuffer(obj) {
      return false;
    },
    
    // Add required properties to satisfy TypeScript
    of: () => {},
    isEncoding: () => false,
    byteLength: () => 0,
    concat: () => []
  };
  
  // Assign our polyfill to the window object
  window.Buffer = BufferPolyfill as any;
}

// Process polyfill
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  const ProcessPolyfill: Process = {
    env: {},
    nextTick: fn => setTimeout(fn, 0),
    version: '',
    // Add required properties to satisfy TypeScript
    stdout: {},
    stderr: {},
    stdin: {},
    argv: []
  };
  
  // Assign our polyfill to the window object
  window.process = ProcessPolyfill as any;
}

// Make sure crypto is available
if (typeof window !== 'undefined' && typeof window.crypto === 'undefined') {
  // @ts-ignore
  window.crypto = {};
}

// Make sure crypto.getRandomValues is available and functioning
if (typeof window !== 'undefined') {
  if (typeof window.crypto.getRandomValues === 'undefined') {
    // Implement a fallback for getRandomValues if it doesn't exist
    window.crypto.getRandomValues = function<T extends ArrayBufferView | null>(array: T): T {
      if (array && array.byteLength) {
        const bytes = new Uint8Array(array.buffer, array.byteOffset, array.byteLength);
        for (let i = 0; i < bytes.length; i++) {
          bytes[i] = Math.floor(Math.random() * 256);
        }
      }
      return array;
    };
  }
  
  // Add subtle crypto if needed
  if (typeof window.crypto.subtle === 'undefined') {
    // @ts-ignore
    window.crypto.subtle = {};
  }
}

// Extend Window interface to recognize our polyfills
declare global {
  interface Window {
    Buffer: BufferConstructor;
    process: Process;
  }
}
